module.exports = __webpack_public_path__ + "img/业界动态.08444723.png";